import { render, staticRenderFns } from "./EmailUnverified.vue?vue&type=template&id=05ab9fdf&"
import script from "./EmailUnverified.vue?vue&type=script&lang=js&"
export * from "./EmailUnverified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports